<template>
  <div class="coleccionesToggle">
    <HeaderShowCol/>
    <div class="titTel">
      <p>Catálogo de la biblioteca</p>
    </div>
    <div class="contenedor">
      <h2>Colecciones</h2>
      <!-- <div class="colecc"> -->
        <div class="container">
          <div class="Col-1"
            @click="routeToShowCol(coleccion)"
            v-for="coleccion in colecciones" :key="coleccion.idCol">
              <p id="textoCol">{{coleccion.nomCol}}</p>
          </div>
        </div>
      <div class="Btn-Cat-Dicc">
        <div class="catastro" @click="routeToShowCol('catastro')">Catastro</div>
        <div class="catastro" @click="routeToShowCol('diccionario')">Diccionario</div>
      </div>
      <!-- <button @click="cierraModalPag2" class="boton">Volver</button> -->
      <div class="campamento" @click="cierraModalPag2">&And;</div>
      <div class="regreso">Regresa al campamento</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import HeaderShowCol from '../components/HeaderShowCol.vue'
export default {
  name: 'Page2',
  components: { HeaderShowCol },
  data () {
    return {

    }
  },
  methods: {
    cierraModalPag2 () {
      this.$router.go(-1)
    },
    routeToShowCol (coleccion) {
      if (coleccion === 'diccionario') {
        this.$router.push({ name: 'VistaCol', params: { nomCol: 'Diccionario', showCol: 'diccionario' } })
      } else {
        if (coleccion === 'catastro') {
          this.$router.push({ name: 'VistaCol', params: { nomCol: 'Catastro', showCol: 'catastro' } })
        } else {
          this.$router.push({ name: 'VistaCol', params: { nomCol: coleccion.nomCol, showCol: coleccion.shoCol } })
        }
      }
    }
    // routeToShowCat () {
    //   console.log('Aquí se mostrará el catastro')
    // }
  },
  computed: {
    ...mapState(['colecciones', 'usuarioEnSesion']),
    sesion () {
      return (this.usuarioEnSesion.nombre === undefined)
    }
  }
}
</script>

<style scoped>
.coleccionesToggle{
  background-image: url("../assets/fondos/FondoEspeleotemaBR.jpg");
  background-size: 100%;
  color: white;
  position: fixed;
  top:0;
  left: 0;
  height: 100vh;
  width:100vw;
  background-repeat: no-repeat;
  background-size: cover;
}
.titTel{
  display: none;
}
.contenedor{
  height: 80vh;
  width: 100%;
  text-align:center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.coleccionesToggle h2{
  font-family: SegoeL;
  font-weight: lighter;
  font-size: 40px;
  color: var(--na);
  /* background-color: rgba(186, 181, 175, 0.8); */
  /* text-shadow: rgb(39, 39, 39) 2px 2px 2px; */
  width:80%;
  max-width: 800px;
  margin-top: 4%;
}
.Btn-Cat-Dicc{
  width: 40%;
  display: flex;
  column-gap: 10px;
}
.catastro {
  font-family: SegoeL;
  font-weight: lighter;
  font-size: 30px;
  color: var(--na);
  width: 75%;
  border:1px solid rgba(0, 75, 105, 0.7);
  background-color: rgba(0, 75, 105, 0.2 );
  text-shadow: 1px 1px rgb(27, 27, 27);
  margin-top: 20px;
  border-radius: 3px;
}
.catastro:hover{
  cursor: pointer;
  background-color: rgba(0, 75, 105, 0.5 );
}
.container {
  width:80%;
  max-width: 800px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 33.3% 33.3% 33.3%;
  color:white;
  font-size: 1.2rem;
  grid-gap:2px;
}

.Col-1{
  font-family: SegoeL;
  background-color:rgba(0, 75, 105, 0.7);
  cursor: pointer;
  /* border: solid 1px orange; */
}
.Col-1:hover {
  background-color:rgba(0, 75, 105, 0.90);
}

p{
  text-decoration: none;
}
li{
  list-style: none;
}
.boton{
  margin-top: 20px;
}
.campamento{
  margin-top: 10px;
  font-size: 35px;
  color:rgb(255, 119, 0);
  transform:scaleX(1.2);
  -moz-transition: all 0.5s ease-out;
  -webkit-transition: all 0.5s ease-out;
  -o-transition: all 0.5s ease-out;
  transition: all 0.5s ease-out;
}
.campamento:hover{
  cursor: pointer;
  transform:translateY(-4px) scaleX(1.2);
}
.regreso{
  font-family: SegoeL;
  font-size: 16px;
  color:dimgray;
}
.Blk-sesion{
 display:flex;
 align-items: center;
 width: 18vw;
 justify-content: space-around;
 /* height: 50%; */
 /* border: solid 1px orange */
}
.icoBib{
  height: 26px;
}
.usuario{
  /* border: solid 1px orange; */
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.icoUser{
  display: inline-block;
  position: relative;
  width: 35px;
  height: 35px;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 15px;
}
.fotoUser{
  width: 100%;
  height: auto;
  margin-top: -12%;
  /* margin-top: 10px;*/
}
.salir{
  border: solid 0px orange
}
.icoSalir{
  height: 24px;
  cursor: pointer;
}
@media screen and (max-width: 575px){
  .container{
    display: flex;
    flex-direction: column;
    font-size: 1rem;
  }
  .titTel{
    display: block;
    background-color: rgba(0, 90, 140, 0.65);
    border: none;
  }
  .titTel p{
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-weight: 200;
    font-size: 32px;
    color:rgb(161, 161, 161);
    /* text-shadow: 1px 1px rgb(0, 0, 0); */
    margin: 0;
    padding-bottom: 10px;
  }
  .contenedor{
    margin-top: 5px;
  }
  .contenedor h2{
    background-color: rgba(156, 127, 47, 0.8);
    color: white;
    margin-bottom: 15px;
    font-size: 32px;
    text-shadow: 2px 2px dimgray;
  }
  .Col-1 p{
    margin: 11px 0px;
    height: 23px;
  }
    #textoCol{
    font-size: 18px;
    line-height: 105%;
  }
  .Btn-Cat-Dicc{
    width:80%;
    display: flex;
    column-gap: 10px;
  }
  .catastro {
    height: 40px;
    font-size: 24px;
    margin-top: 15px;
    padding: 0 5px;
    padding-bottom: 4px;
    background-color: rgba(0, 75, 105, 0.6 );
  }
}
@media screen and (max-width: 376px){
  .titTel p{
    font-size: 28px;
  }
  .contenedor{
    margin-top: 0px;
  }
  .contenedor h2{
    font-size: 1.6rem;
    /* line-height: 100%; */
  }
  .Col-1 p{
    margin: 8.5px 0px;
    font-size: 0.9rem;
    height: 20px;
  }
  #textoCol{
    font-size: 17px;
    margin: 8px 0;
    line-height: 105%;
  }
  .catastro{
    font-size: 1.1rem;
    height: 32px;
  }
  .campamento{
    margin-top: 5px;
  }
  .regreso{
    line-height: 105%;
}
}
</style>
